import { images, links } from "@/data";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <img className="footer__logo" src={images.logoColor} alt="HI Tours Group" />
            <p className="footer__tagline">Trusted by travelers, travel brands, and companies worldwide.</p>
            <div className="footer__socials">
              <a href={links.linkedin} target="_blank" rel="noopener noreferrer" className="footer__social">
                <img src={images.linkedin} alt="" aria-hidden="true" />Linkedin
              </a>
              <a href={links.instagram} target="_blank" rel="noopener noreferrer" className="footer__social">
                <img src={images.instagram} alt="" aria-hidden="true" />Instagram
              </a>
              <a href={links.facebook} target="_blank" rel="noopener noreferrer" className="footer__social">
                <img src={images.facebook} alt="" aria-hidden="true" />Facebook
              </a>
            </div>
          </div>

          <div className="footer__cols">
            <div className="footer__col">
              <h4>Brands</h4>
              <a href={links.hiDMC} target="_blank" rel="noopener noreferrer">Hi DMC</a>
              <a href={links.hiOffsite} target="_blank" rel="noopener noreferrer">Hi Offsite</a>
              <a href={links.hiTours} target="_blank" rel="noopener noreferrer">Hi Tours</a>
            </div>
            <div className="footer__col">
              <h4>Company</h4>
              <Link to="/about">About</Link>
              <Link to="/partner">Partner</Link>
              <Link to="/insights">Insights</Link>
              <Link to="/brands">Brands</Link>
              <a href={links.careers} target="_blank" rel="noopener noreferrer">Careers</a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© Hi Tours India Pvt. Ltd. All Rights Reserved.</span>
          <span className="footer__bottom-links">
            <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">Sitemap</a>
            <a href="/llms.txt" target="_blank" rel="noopener noreferrer">For AI &amp; LLMs</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
